import { Component, OnInit, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'vp-custom-snackbar-message',
    templateUrl: './custom-snackbar-message.component.html',
    standalone: false
})
export class CustomSnackbarMessageComponent implements OnInit {
    private data = inject<{
        message: string;
        action: string;
    }>(MAT_SNACK_BAR_DATA);
    private snackBarRef = inject<MatSnackBarRef<CustomSnackbarMessageComponent>>(MatSnackBarRef);

    public message: string;
    public action: string;

    public ngOnInit(): void {
        this.message = this.data.message || '';
        this.action = this.data.action || '';
    }

    public dismiss(): void {
        this.snackBarRef.dismiss();
    }
}
